import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";

class FaqPage extends Component {
  render() {
    return (
      <Grid
        container
        direction={"row"}
        alignItems={"left"}
        style={{ textAlign: "left", width: "100%" }}
      >
        <Grid item lg={12}>
          <Box p={2}>
            <Divider />
            <Box p={3}>
              <Typography variant={"h4"}>Data Submission</Typography>
            </Box>
            <Box p={3}>
              <Grid
                container
                direction={"row"}
                justify={"left"}
                alignItems={"left"}
                spacing={1}
              >
                <Grid item lg={12}>
                  <p>2-steps:</p>
                  <Link to="/submitdatasets" data-cy="step1">1. Create Dataset</Link>
                  <Box p={3}>
                    <li>First we need to create a "folder" for your data</li>
                    <li>
                      The "folder name" in our system is called{" "}
                      <i>Dataset ID</i>
                      (e.g. 3TR_antiTNF-response)
                    </li>
                    <li>
                      You can give it a more human readable name under{" "}
                      <i>Dataset Name</i>
                      (e.g. antiTNF response signatures)
                    </li>
                    <li>
                      Paste a meaningful dataset description into{" "}
                      <i>Dataset Description</i>
                    </li>
                    <li>The other fields should be self explanatory</li>
                    <li>
                      Note all "folders" are defaulted to private (you can
                      change it later <Link to="/datasets" data-cy="datasetsView1">here</Link>) or you
                      can set it to visible to all in the column{" "}
                      <i>Visibility</i>
                    </li>
                    <li>
                      To make sure that all the data is filled in correctly and
                      no mandatory fields are left blank you can click on
                      VALIDATE
                    </li>
                    <li>
                      Click on SUBMIT (you find your submissions{" "}
                      <Link to="/datasets" data-cy="datasetsView2">here</Link>)
                    </li>
                  </Box>
                  <Link to="/uploadfiles/selectproject" data-cy="step2">2. Upload Files</Link>
                  <Box p={3}>
                    <li>
                      First select the "folder" (<i>Dataset ID</i>) you have
                      created in #1 (the selection box is searchable)
                    </li>
                    <li>
                      Select one/multiple file/s from your computer (supported
                      file formats: .tsv,.csv,.txt,.xlsx,.xls,.rds,.rda,.h5ad)
                    </li>
                    <li>
                      Please select the platform you have used to collect the
                      data (e.g. Illumina, Affymetrix etc.) if it is not in the
                      list select other and indicate the platform name under{" "}
                      <i>Comments</i>
                    </li>
                    <li>
                      To make sure that all the data is filled in correctly, the
                      file type is supported and no mandatory fields are left
                      blank you can click on VALIDATE
                    </li>
                    <li>
                      Click on SUBMIT (you find your submissions{" "}
                      <Link to="/datasets" data-cy="filesView">here</Link>)
                    </li>
                  </Box>
                  <Box p={1}>
                    <Typography variant={"h6"}>
                      -> Tip: in both submission steps the table can be filled in by uploading a .tsv
                    </Typography>
                  </Box>
                  <Box p={3}>  
                  <li>
                    First get the template by clicking on DOWNLOAD TEMPLATE
                  </li>
                  <li>
                    Open the downloaded .xlsx with a spreadsheet application and replace the dummy data
                  </li>
                  <li>
                    save the file as <font color="red">tab separated</font> text file (.tsv,.csv,.txt)
                  </li>
                  <li>
                    Upload the file by clicking on "Browse..." and select the file
                  </li>
                  </Box>
                  <Box p={3}>
                    <Typography variant={"h4"}>FAQ</Typography>
                  </Box>
                  <Box p={3}>
                    <li>
                      What happens if I accidentally create "folder" with the
                      same name as an existing one? -> The validation will fail
                      and you are asked to change the "folder name"
                    </li>
                    <li>
                      What happens if I upload a file with the same name as an
                      existing one? -> The existing one will not be overwritten
                      but the new one will be added with version number (i+1)
                    </li>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  }
}

export default FaqPage;
